import css from 'styled-jsx/css';

export default css`
  .question {
    display: none;
  }
  @media (max-width: 767px) {
    .question {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 15px;
      padding: 10px;
      gap: 10px;
      border-radius: 10px;
      border: 2px dotted #a41c1c;
    }
  }
  .question > h1 {
    margin: 0;
    font-family: 'Eurostile-Bold';
    font-size: 24px;
  }
  .question > span {
    font-family: 'Roboto-Normal';
    font-size: 12px;
  }
  .smiles {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    gap: 10px;
  }
`;
